import { createSvgComponent } from "../../icon/createSvgComponent";
import LocationPinFill from "@core/__generated__/icon/figma/location-pin-fill.svg";
export default createSvgComponent(LocationPinFill);